import { createConfirmation } from 'react-confirm'
import MessageDialog from '_components/message-dialog'

const dialog = createConfirmation(MessageDialog)

export default (message, options = {}) => { return dialog({ message, options, }).then(() => { return true }, () => { return false }) }
